module.exports = __webpack_public_path__ + "img/消息中心.4aeac4c5.svg";